import { BsFiletypeHtml, BsFiletypeCss, BsBootstrap } from "react-icons/bs";
import { FaNodeJs } from "react-icons/fa";
import {
  SiJavascript,
  SiReact,
  SiTailwindcss,
  SiMongodb,
  SiMysql,
  SiTypescript,
  SiGithub,
  SiWordpress,
  SiExpress,
  SiAngular,
  SiAzurefunctions,
  SiTalend,
  SiPowerbi,
  SiDotnet,
  SiSnowflake,
} from "react-icons/si";
import { IoLogoIonic } from "react-icons/io";
import { DiRedis } from "react-icons/di";

export const TechstackList = [
  {
    _id: 1,
    name: "HTML",
    icon: BsFiletypeHtml,
  },
  {
    _id: 2,
    name: "CSS / SCSS",
    icon: BsFiletypeCss,
  },
  {
    _id: 3,
    name: "Bootstrap",
    icon: BsBootstrap,
  },
  {
    _id: 4,
    name: "Javascript",
    icon: SiJavascript,
  },
  {
    _id: 5,
    name: "TypeScript",
    icon: SiTypescript,
  },
  {
    _id: 6,
    name: "Angular",
    icon: SiAngular,
  },
  {
    _id: 7,
    name: "React JS",
    icon: SiReact,
  },
  {
    _id: 8,
    name: "Ionic",
    icon: IoLogoIonic,
  },
  {
    _id: 9,
    name: ".NET Core",
    icon: SiDotnet,
  },
  {
    _id: 10,
    name: "Tailwind",
    icon: SiTailwindcss,
  },
  {
    _id: 11,
    name: "React Native",
    icon: SiReact,
  },
  {
    _id: 12,
    name: "Node JS",
    icon: FaNodeJs,
  },
  {
    _id: 13,
    name: "Express JS",
    icon: SiExpress,
  },
  {
    _id: 14,
    name: "WordPress",
    icon: SiWordpress,
  },
  {
    _id: 15,
    name: "MongoDB",
    icon: SiMongodb,
  },
  {
    _id: 16,
    name: "MSQL",
    icon: SiMysql,
  },
  {
    _id: 17,
    name: "Redis",
    icon: DiRedis,
  },
  {
    _id: 18,
    name: "Snowflake",
    icon: SiSnowflake,
  },
  {
    _id: 19,
    name: "Git / GitHub",
    icon: SiGithub,
  },
  {
    _id: 20,
    name: "Power BI",
    icon: SiPowerbi,
  },
  {
    _id: 21,
    name: "Azure Functions",
    icon: SiAzurefunctions,
  },
  {
    _id: 22,
    name: "Talend ETL",
    icon: SiTalend,
  },
];
